
import { WorldCountry } from '../types';

export const nigeriaExpanded3: WorldCountry = {
  code: 'NG',
  name: 'Nigeria',
  slug: 'nigeria',
  population: 218541000,
  topCities: [
    // Ciudades principales existentes
    { name: 'Lagos', slug: 'lagos', population: 15388000 },
    { name: 'Kano', slug: 'kano', population: 4348000 },
    { name: 'Ibadan', slug: 'ibadan', population: 3649000 },
    { name: 'Abuja', slug: 'abuja', population: 3278000 },
    { name: 'Port Harcourt', slug: 'port-harcourt', population: 1865000 },
    { name: 'Benin City', slug: 'benin-city', population: 1782000 },
    { name: 'Maiduguri', slug: 'maiduguri', population: 1470000 },
    { name: 'Zaria', slug: 'zaria', population: 1018000 },
    { name: 'Aba', slug: 'aba', population: 967000 },
    { name: 'Jos', slug: 'jos', population: 816000 },
    
    // Nuevas ciudades - Expansión Fase 9
    { name: 'Ilorin', slug: 'ilorin', population: 800000 },
    { name: 'Oyo', slug: 'oyo', population: 780000 },
    { name: 'Enugu', slug: 'enugu', population: 750000 },
    { name: 'Abeokuta', slug: 'abeokuta', population: 720000 },
    { name: 'Kaduna', slug: 'kaduna', population: 700000 },
    { name: 'Akure', slug: 'akure', population: 680000 },
    { name: 'Bauchi', slug: 'bauchi', population: 650000 },
    { name: 'Sokoto', slug: 'sokoto', population: 630000 },
    { name: 'Owerri', slug: 'owerri', population: 600000 },
    { name: 'Calabar', slug: 'calabar', population: 580000 },
    { name: 'Uyo', slug: 'uyo', population: 560000 },
    { name: 'Katsina', slug: 'katsina', population: 540000 },
    { name: 'Ado-Ekiti', slug: 'ado-ekiti', population: 520000 },
    { name: 'Gombe', slug: 'gombe', population: 500000 },
    { name: 'Minna', slug: 'minna', population: 480000 },
    { name: 'Yola', slug: 'yola', population: 460000 },
    { name: 'Warri', slug: 'warri', population: 440000 },
    { name: 'Osogbo', slug: 'osogbo', population: 420000 },
    { name: 'Makurdi', slug: 'makurdi', population: 400000 },
    { name: 'Lafia', slug: 'lafia', population: 380000 },
    { name: 'Ilesa', slug: 'ilesa', population: 360000 },
    { name: 'Jalingo', slug: 'jalingo', population: 340000 },
    { name: 'Lokoja', slug: 'lokoja', population: 320000 },
    { name: 'Ikom', slug: 'ikom', population: 300000 },
    { name: 'Okene', slug: 'okene', population: 290000 },
    { name: 'Ugep', slug: 'ugep', population: 280000 },
    { name: 'Ogbomoso', slug: 'ogbomoso', population: 270000 },
    { name: 'Iwo', slug: 'iwo', population: 260000 },
    { name: 'Ede', slug: 'ede', population: 250000 },
    { name: 'Ila Orangun', slug: 'ila-orangun', population: 240000 },
    { name: 'Offa', slug: 'offa', population: 230000 },
    { name: 'Ikire', slug: 'ikire', population: 220000 },
    { name: 'Shaki', slug: 'shaki', population: 210000 },
    { name: 'Iseyin', slug: 'iseyin', population: 200000 },
    { name: 'Kishi', slug: 'kishi', population: 190000 },
    { name: 'Eruwa', slug: 'eruwa', population: 180000 },
    { name: 'Igboho', slug: 'igboho', population: 170000 },
    { name: 'Saki', slug: 'saki', population: 160000 },
    { name: 'Igbeti', slug: 'igbeti', population: 150000 },
    { name: 'Ago-Are', slug: 'ago-are', population: 145000 },
    { name: 'Iwere-Ile', slug: 'iwere-ile', population: 140000 },
    { name: 'Fiditi', slug: 'fiditi', population: 135000 },
    { name: 'Iganna', slug: 'iganna', population: 130000 },
    { name: 'Tede', slug: 'tede', population: 125000 },
    { name: 'Ilero', slug: 'ilero', population: 120000 },
    { name: 'Igbaja', slug: 'igbaja', population: 115000 },
    { name: 'Ajasse-Ipo', slug: 'ajasse-ipo', population: 110000 },
    { name: 'Pategi', slug: 'pategi', population: 105000 },
    { name: 'Kaiama', slug: 'kaiama', population: 100000 },
    { name: 'Yashikira', slug: 'yashikira', population: 95000 },
    { name: 'Kosubosu', slug: 'kosubosu', population: 90000 },
    { name: 'Gwanara', slug: 'gwanara', population: 85000 },
    { name: 'Rogun', slug: 'rogun', population: 80000 },
    { name: 'Lanwa', slug: 'lanwa', population: 75000 },
    { name: 'Okuta', slug: 'okuta', population: 70000 },
    { name: 'Bode Saadu', slug: 'bode-saadu', population: 65000 },
    { name: 'Bacita', slug: 'bacita', population: 60000 },
    { name: 'Jebba', slug: 'jebba', population: 55000 },
    { name: 'Mokwa', slug: 'mokwa', population: 50000 },
    { name: 'New Bussa', slug: 'new-bussa', population: 48000 },
    { name: 'Wawa', slug: 'wawa', population: 46000 },
    { name: 'Agaie', slug: 'agaie', population: 44000 },
    { name: 'Lapai', slug: 'lapai', population: 42000 },
    { name: 'Bida', slug: 'bida', population: 40000 },
    { name: 'Gbako', slug: 'gbako', population: 38000 },
    { name: 'Katcha', slug: 'katcha', population: 36000 },
    { name: 'Kontagora', slug: 'kontagora', population: 34000 },
    { name: 'Mariga', slug: 'mariga', population: 32000 },
    { name: 'Mashegu', slug: 'mashegu', population: 30000 },
    { name: 'Muya', slug: 'muya', population: 28000 },
    { name: 'Paikoro', slug: 'paikoro', population: 26000 },
    { name: 'Rafi', slug: 'rafi', population: 24000 },
    { name: 'Rijau', slug: 'rijau', population: 22000 },
    { name: 'Shiroro', slug: 'shiroro', population: 20000 },
    { name: 'Suleja', slug: 'suleja', population: 18000 },
    { name: 'Tafa', slug: 'tafa', population: 16000 },
    { name: 'Wushishi', slug: 'wushishi', population: 14000 },
    { name: 'Borgu', slug: 'borgu', population: 12000 },
    { name: 'Gurara', slug: 'gurara', population: 10000 },
    { name: 'Magama', slug: 'magama', population: 9500 },
    { name: 'Edati', slug: 'edati', population: 9000 },
    { name: 'Bosso', slug: 'bosso', population: 8500 },
    { name: 'Chanchaga', slug: 'chanchaga', population: 8000 },
    { name: 'Gbako LGA', slug: 'gbako-lga', population: 7500 },
    { name: 'Lavun', slug: 'lavun', population: 7000 },
    { name: 'Mokwa LGA', slug: 'mokwa-lga', population: 6500 },
    { name: 'Agwara', slug: 'agwara', population: 6000 },
    { name: 'Magama LGA', slug: 'magama-lga', population: 5500 },
    { name: 'Mariga LGA', slug: 'mariga-lga', population: 5000 }
  ]
};
